module.exports = __webpack_public_path__ + "img/Home-anli-3.62be4cf8.png";